module.exports = __webpack_public_path__ + "static/img/pro-3-220x294.0c40a77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pro-3-220x294.jpg
// module id = rTPC
// module chunks = 1